import { render, staticRenderFns } from "./CloseoutDetailPage.vue?vue&type=template&id=619a10b4&scoped=true&"
import script from "./CloseoutDetailPage.vue?vue&type=script&lang=js&"
export * from "./CloseoutDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./CloseoutDetailPage.vue?vue&type=style&index=0&id=619a10b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619a10b4",
  null
  
)

export default component.exports